import React from "react";
import styled, { css } from "styled-components";
import SafeSiteImage from "./SafeSiteImage";

const FullWidthBannerStyles = styled.div`
  ${({ ...props }) => css`
  .section--grey + & {
    padding-top: 3rem;
  }
  & + .section--grey {
    padding-bottom: 3rem
  }
  * {
    width: 100%
  }
  img:last-child {
    display: none !important;
  }

  @media (min-width: ${props.theme.breakpoints.md}) {
    img:first-child {
      display: none !important;
    }
    img:last-child {
      display: inline-block !important;
    }
  }
  `}
`;

export const FullWidthBanner = ({ mobileImage, desktopImage, pdfLink }) => {
  return (
    <FullWidthBannerStyles>
        {pdfLink ? (
            <a href={pdfLink} target="_blank" rel="noopener noreferrer">
                <SafeSiteImage image={mobileImage.mediaItemUrl} alt={mobileImage.altText ?? ''} width="768" />
                <SafeSiteImage image={desktopImage.mediaItemUrl} alt={desktopImage.altText ?? ''} width="1920" />
            </a>
        ) : (
            <>
                <SafeSiteImage image={mobileImage.mediaItemUrl} alt={mobileImage.altText ?? ''} width="768" />
                <SafeSiteImage image={desktopImage.mediaItemUrl} alt={desktopImage.altText ?? ''} width="1920" />
            </>
        )}
    </FullWidthBannerStyles>
  );
};
